import React from 'react'
import Comingsoon from '../components/organisms/Comingsoon'

function Presale() {
    return (
        <>
            <Comingsoon />
        </>
    )
}

export default Presale
